((app) => {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Root.DataFlow", {
            url: "/DataFlow",
            component: "dataflow"
        });
    }]);

    app.component("dataflow", {
        templateUrl: "/App/States/DataFlow/dataflow.html",
        controller: dataflowCtrl
    });

    dataflowCtrl.$inject = ["$q", "carrierDataApi"];
    function dataflowCtrl($q, carrierDataApi) {
        $ctrl = this;
        $ctrl.ui = {};

        $ctrl.$onInit = () => {
            $ctrl.queryAll();
        };

        $ctrl.queryAll = () => {
            _queryDataFlow();
        };

        $ctrl.refresh = function () {
            _queryDataFlow();
        };

        function _queryDataFlow() {
            $ctrl.ui.dataFlowLoading = true;
            var staleData = [];
            var healthyData = [];
            _throttle(carrierDataApi.getDataFlow())
                .then((results) => {
                    results.forEach((r) => {
                        r.Stale = _checkFrequency(r);
                        r.Stale ? staleData.push(r) : healthyData.push(r);
                    });
                    $ctrl.dataFlow = {
                        stale: staleData,
                        healthy: healthyData
                    };
                })
                .finally(() => {
                    $ctrl.ui.dataFlowLoading = false;
                });
        }

        function _checkFrequency(track) {
            return new Date(track.LastReceivedDate) < new Date(moment().subtract(track.FileProcessorTrackFrequencyInterval * 3, track.FileProcessorTrackFrequencyType)) ? true : false;
        }

        // When the data loads too fast it doesn't make for a very smooth UX. So
        // we'll throttle that transition.
        // Need to run the api calls with the $q Service. It's integrated into
        // the angular digest cycle so the model will automatically update so
        // the child component doesn't have to worry about watching changes
        function _throttle(promise) {
            return $q((resolve) => {
                setTimeout(() => {
                    return resolve($q.when(promise));
                }, 500);
            });
        }
    }
})(window.app);